import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import Paging from 'components/Paging'
require("./deucationTrainingPolicy.css");

let list = [
  {
    list_txt: "融融暖意，激发练兵动力：各地拥军优抚法治化",
    list_time: "2018-11-05"
  },
  {
    list_txt: "基干民兵成为优抚贷款受益人",
    list_time: "2018-11-05"
  },
  {
    list_txt: "2019年，退役军人优抚工作将有这些变化",
    list_time: "2018-11-05"
  },
  {
    list_txt: "四个关键词一览退役军人拥军优抚褒扬新进展",
    list_time: "2018-11-05"
  },
  {
    list_txt: "退役军人事务部与10家银行签署拥军优抚合作协议",
    list_time: "2018-11-05"
  },
  {
    list_txt: "退役军人优抚安置工作进入发展新时期",
    list_time: "2018-11-05"
  },
  {
    list_txt: "退役军人事务部办公厅关于进一步加强军队离退休干部安全管理工作的通知...",
    list_time: "2018-11-05"
  },
  {
    list_txt: "融融暖意，激发练兵动力：各地拥军优抚法治化",
    list_time: "2018-11-05"
  },
  {
    list_txt: "基干民兵成为优抚贷款受益人",
    list_time: "2018-11-05"
  },
  {
    list_txt: "四个关键词一览退役军人拥军优抚褒扬新进展",
    list_time: "2018-11-05"
  },
  {
    list_txt: "四个关键词一览退役军人拥军优抚褒扬新进展",
    list_time: "2018-11-05"
  },
  {
    list_txt: "退役军人事务部办公厅关于进一步加强军队离退休干部安全管理工作的通知...",
    list_time: "2018-11-05"
  },
  {
    list_txt: "四个关键词一览退役军人拥军优抚褒扬新进展",
    list_time: "2018-11-05"
  },
  {
    list_txt: "融融暖意，激发练兵动力：各地拥军优抚法治化",
    list_time: "2018-11-05"
  },
  {
    list_txt: "基干民兵成为优抚贷款受益人",
    list_time: "2018-11-05"
  }
]
export default class DeucationTrainingPolicy extends PureComponent {
  constructor(props) {
    super(props);

  }

  renderList(list) {
    var arr = [];
    for (var i = 0; i < list.length; i++) {
      var temp = <li key={i}>
        <Link to="/educationTraining/deucationTrainingPolicyDetail">
          <div className="content_list_dot"></div>
          <div className="content_list_txt">{list[i].list_txt}</div>
          <div className="content_list_time">{list[i].list_time}</div>
        </Link>
      </li>
      arr.push(temp);
    }
    return arr;
  }

  render() {
    return (
      <div>
        {/* 内容 */}
        <div className="content">
          <div className="container clear">
            <div className="content_list" style={{ width: '100%' }}>
              <ul>
                {
                  this.renderList(list)
                }
              </ul>
              <Paging />
            </div>
          </div>
        </div>
        {/* 内容 */}
      </div>
    );
  }
}
